import { HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { BranchSelectionParameter, BranchSelectionResultModel } from "@WhiteCap/Handlers/BranchSelection/HandleBranchSelection";

const branchSelectionUrl = "/api/v1/branchSelection";

export function handleBranchSelectionService(parameter: Readonly<BranchSelectionParameter & HasOnSuccess<BranchSelectionResultModel>>): BranchSelectionResultModel | PromiseLike<BranchSelectionResultModel> {
    return post<BranchSelectionResultModel>(`${branchSelectionUrl}?lat=${parameter.latitude}&lon=${[parameter.longitude]}`);
} 
